import { render, staticRenderFns } from "./ItemStatsDisplayWeapon.vue?vue&type=template&id=e013ed82"
import script from "./ItemStatsDisplayWeapon.vue?vue&type=script&lang=js"
export * from "./ItemStatsDisplayWeapon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports